import angular from 'angular';
import uiRouter from 'angular-ui-router';
import VoucherCollectionComponent from './voucher-collection.component';

let VoucherCollectionModule = angular.module('VoucherCollection', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('voucherCollection', {
            url: '/vouchers/collection/:id',
            component: 'voucherCollection',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN', 'VOUCHERS', 'VOUCHERCOLLECTOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                voucher: (
                    VouchersService,
                    $stateParams
                ) => {
                    return VouchersService.findById($stateParams.id, {
                        include: [
                            'worker',
                            {
                                relation: 'generatedPendingSpendings',
                                scope: {
                                    include: ['registry']
                                }
                            },
                            {
                                relation: 'operativeSpendings',
                                scope: {
                                    include: ['holder', 'vehicle']
                                }
                            },
                            {
                                relation: 'spendings',
                                scope: {
                                    include: ['spendingType']
                                }
                            }
                        ]
                    });
                },
                cashReturns: (VouchersService, $stateParams) => {
                    return VouchersService.findCashReturns(
                        parseInt($stateParams.id, 10)
                    ).then(res => res.transactions);
                },
                registries: (RegistriesService) => {
                    return RegistriesService.find();
                },
                cashboxes: (CashboxesService) => {
                    return CashboxesService.find({
                        include: ['employee'],
                        order: 'id ASC'
                    });
                }
            }
        });
})
.component('voucherCollection', VoucherCollectionComponent)
.name;

export default VoucherCollectionModule;
